import { NewDestination } from 'types/stream';

type GetDestinationsProps = {
  baseUrl: string;
  twitchRedirectUrl?: string;
  youtubeRedirectUrl?: string;
  facebookRedirectUrl?: string;
  linkedinRedirectUrl?: string;
  instagramRedirectUrl?: string;
  onRTMPClick?: () => void;
  onTwitchClick?: () => void;
  onAmazonLiveClick?: () => void;
  onLinkedinPageClick?: () => void;
  onLinkedinProfileClick?: () => void;
  onInstagramClick?: () => void;
  onYoutubeClick?: () => void;
  onFacebookClick?: () => void;
  onFacebookGroupClick?: () => void;
};

const getDestinations = ({
  baseUrl,
  twitchRedirectUrl = '',
  linkedinRedirectUrl = '',
  facebookRedirectUrl = '',
  youtubeRedirectUrl = '',
  instagramRedirectUrl = '',
  onRTMPClick,
  onTwitchClick,
  onYoutubeClick,
  onFacebookClick,
  onInstagramClick,
  onAmazonLiveClick,
  onLinkedinPageClick,
  onFacebookGroupClick,
  onLinkedinProfileClick
}: GetDestinationsProps): NewDestination[] =>
  [
    {
      url: `${baseUrl}streaming/social/auth/facebook?scopeKind=page&redirect_uri=${facebookRedirectUrl}`,
      kind: 'page',
      title: 'Facebook page',
      network: 'FACEBOOK',
      onClick: onFacebookClick
    },
    {
      url: `${baseUrl}streaming/social/auth/facebook?scopeKind=group&redirect_uri=${facebookRedirectUrl}`,
      kind: 'group',
      title: 'Facebook group',
      network: 'FACEBOOK',
      onClick: onFacebookGroupClick
    },
    {
      url: `${baseUrl}streaming/social/auth/facebook?scopeKind=user&redirect_uri=${facebookRedirectUrl}`,
      kind: 'profile',
      title: 'Facebook profile',
      network: 'FACEBOOK',
      onClick: onFacebookClick
    },
    {
      url: `${baseUrl}streaming/social/auth/youtube?redirect_uri=${youtubeRedirectUrl}`,
      title: 'YouTube',
      network: 'YOUTUBE',
      onClick: onYoutubeClick
    },
    {
      url: `${baseUrl}streaming/social/auth/twitch?redirect_uri=${twitchRedirectUrl}`,
      title: 'Twitch',
      network: 'TWITCH',
      onClick: onTwitchClick
    },
    {
      url: `${baseUrl}streaming/social/auth/linkedin?scopeKind=user&redirect_uri=${linkedinRedirectUrl}`,
      kind: 'profile',
      title: 'Linkedin profile',
      network: 'LINKEDIN',
      onClick: onLinkedinProfileClick
    },
    {
      url: `${baseUrl}streaming/social/auth/linkedin?scopeKind=page&redirect_uri=${linkedinRedirectUrl}`,
      kind: 'page',
      title: 'Linkedin page',
      network: 'LINKEDIN',
      onClick: onLinkedinPageClick
    },
    {
      url: `${baseUrl}streaming/social/auth/instagram?redirect_uri=${instagramRedirectUrl}`,
      title: 'Instagram',
      network: 'INSTAGRAM',
      onClick: onInstagramClick
    },
    {
      url: ``,
      title: 'Custom RTMP',
      network: 'RTMP',
      onClick: onRTMPClick
    },
    {
      url: ``,
      title: 'Amazon Live',
      network: 'RTMP',
      kind: 'AmazonLive',
      onClick: onAmazonLiveClick
    }
  ].filter(Boolean) as NewDestination[];

export default getDestinations;
